<template>
  <div>
    <the-nav-bar :title="$t('rebate.rankList')" />
    <div class="body-wrapper" v-if="isLoaded && list.length">
      <h2 class="title">{{ $t('rebate.rank') }}</h2>
      <p class="brief" v-text="$t('rebate.rankBrief')"></p>
      <table class="rank">
        <tr>
          <th>{{ $t('rebate.rank') }}</th>
          <th>{{ $t('rebate.nickname') }}</th>
          <th>{{ $t('rebate.revenue') }}</th>
        </tr>
        <tr v-for="(item, index) in list" :key="index">
          <td>
            <img
              v-if="index < 3"
              :src="require(`@/images/icons/icon-cup-${index + 1}.svg`)"
              :alt="index"
              class="icon"
            />
            <span class="rank-num row-center" v-else>{{ index + 1 }}</span>
          </td>
          <td>{{ item.name }}</td>
          <td>{{ item.commission }} {{ item.symbol }}</td>
        </tr>
      </table>

      <help-bar />
    </div>
    <div class="empty-wrapper col-center" v-if="isLoaded && list.length == 0">
      <img src="@/images/record-empty.svg" alt="No Found" class="img" />
      <span class="text">{{ $t('rebate.noRecords') }}</span>
    </div>
  </div>
</template>

<script>
import TheNavBar from '@/components/the-nav-bar';
import HelpBar from '@/components/help-bar';
import { Toast } from 'mand-mobile';
import { getCommissionRank } from '@/api/commission.js';
export default {
  components: {
    TheNavBar,
    HelpBar,
  },
  data() {
    return {
      isLoaded: false,
      list: [],
    };
  },
  mounted() {
    this.loadData()
      .then(() => {
        this.isLoaded = true;
      })
      .catch(err => {
        Toast.failed(err.message);
      });
  },
  methods: {
    loadData() {
      return getCommissionRank().then(data => {
        if (Array.isArray(data.data)) {
          data.data.forEach(item => {
            this.list.push(item);
          });
        }
      });
    },
  },
};
</script>

<style lang="stylus" scoped>
.body-wrapper {
  padding: 4.8vw 4.8vw 60vw;
}

.title {
  margin: 0;
  font-size: 3.73vw;
  line-height: 6.4vw;
}

.brief {
  font-size: 2.67vw;
  line-height: 4.8vw;
  color: #84969C;
}

.rank {
  margin: 4.8vw 0;
  text-align: left;
  font-size: 2.67vw;
  line-height: 4.8vw;

  tr {
    border-bottom: 0.27vw solid #EAF1F3;
  }

  th {
    padding: 2.67vw 0;
  }

  td {
    padding: 2.67vw 0;
    color: #84969C;
  }

  .icon, .rank-num {
    margin-right: 8vw;
    width: 4.8vw;
    height: 4.8vw;
    font-weight: 600;
  }
}

.empty-wrapper {
  min-height: 80vw;

  .img {
    width: 25.33vw;
  }

  .text {
    margin-top: 4.8vw;
    font-size: 3.2vw;
    color: #84969C;
  }
}
</style>
